module.exports = require("@material-ui/core/InputAdornment");